// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea9004b1","389":"7c02ffe8","453":"1e07944d","732":"dd9b2b25","977":"862309c6"}[chunkId] + ".chunk.js";
};